<script>
import { isEmpty } from "lodash";
import AutocompleteWithMap from "../../../../components/AutocompleteWithMap.vue";
import Actions from "../Actions.vue";
import AdvancedCourseHeader from "../../../../components/AdvancedCourseHeader.vue";
import GoogleMap from "@/components/GoogleMap.vue";
import { format } from "../../../../libs/date.format.js";
import datesMixins from "../../../../mixins/datesMixins";
import submitAdvancedFlow from "../../../../mixins/submitAdvancedFlow";
import methods from "../../../management-panel/components/AdvancedAddVenue/methods";

const {
    getExistingVenues,
} = methods;

const COURSE_DATES = "courseDates";

const AddVenuetoCourse = {
    mixins: [datesMixins, submitAdvancedFlow],
    data() {
        return {
            course: null,
            onMapPage: true,
            showAutocompleteMap: true,
            titleText: "Add a venue",
            autocompleteTxtboxError: "",
            nextButtonText: "Next",
            nextButtonDisabled: false,
            venue: {},
            showOverlay: false,

            existingVenues: [],
            lati: 55.77582304985938,
            longi: -4.050905403411567,
            zoom: 15,
            noMovePin: true,
            showExistingVenueMap: false,

            showManualTitle: false,
        };
    },
    name: "AddVenuetoCourse",
    components: {
        AutocompleteWithMap,
        AdvancedCourseHeader,
        Actions,
        GoogleMap,
    },
    methods: {
        addNewVenue(data) { /* listens to the emited event , run this call back */
            this.venue = data; // required
        },
        venueExistingSelectedListFor(existingV) {
            this.longi = parseFloat(existingV.lng);
            this.lati = parseFloat(existingV.lat);
            this.showExistingVenueMap = true;
        },
        backActionBtn() {
            if (this.onMapPage === false) { /* on summary page */
                // now we go back to map page
                this.onMapPage = true;
                // this.$refs.childMap.confirmLocation();
                this.$refs.childMap.manualAddress = !this.$refs.childMap.manualAddress;
                this.nextButtonText = "Next";
            } else {
                this.$router.push({ name: "Advanced Add Holiday" });
            }
        },
        nextBtn() {
            if (this.onMapPage === false) {
                this.$refs.childMap.saveVenue(true);

                this.$storage.setStorageSync("venue", this.venue);
                if (Object.values(this.venue).length > 0) {
                    this.submitAdvancedFlow();
                }
            } else if (this.showExistingVenueMap) {
                this.$storage.setStorageSync("venue", this.venue);
                if (Object.values(this.venue).length > 0) {
                    this.submitAdvancedFlow();
                }
            } else {
                const mapTxt = document.querySelector("input#map");
                if (this.onMapPage === true && !isEmpty(mapTxt.value)) {
                    this.$refs.childMap.confirmLocation(); // toggles AutocompleteWithMap.manualAddress (which is used to v-show Map)
                    // ok to goto summary page
                    this.onMapPage = false;
                    this.autocompleteTxtboxError = "";
                    this.nextButtonText = "Add Venue";
                    this.$refs.childMap.validateForm(); // automatically show errors on form if coming from map (autocomplete) page
                } else {
                    this.autocompleteTxtboxError = "Enter an address";
                }
            }
        },
        upperFirst(word) {
            if (word === undefined) {
                return "";
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        },
        manualAutoToggled(hideMap) {
            this.onMapPage = !this.onMapPage;
            if (hideMap === true) {
                this.autocompleteTxtboxError = "";
                this.nextButtonText = "Add Venue";
            } else {
                this.nextButtonText = "Next";
            }
        },
        submitEditModal(data) {
            this.course = { ...this.course, ...data };
            this.$storage.setStorageSync(COURSE_DATES, this.course);
            this.checkHolidays();
        },
        userClickedMap() {
            this.showOverlay = true;
        },
        userClickedAlocationOnMap() {
            this.showOverlay = false;
        },
        hideOverlayIfUserClicked() {
            this.showOverlay = false;
        },
    },
    async mounted() {
        this.course = this.$storage.getStorageSync(COURSE_DATES) || null;

        const venues = await getExistingVenues();
        this.existingVenues = venues;
    },
    computed: {
        getCurrentCourseDates() {
            const startWeekday = this.getWeekdayFromDate(new Date(this.course?.plainStartDate));
            const endWeekDay = this.getWeekdayFromDate(new Date(this.course?.plainEndDate));
            return ` ${startWeekday} ${format(this.course?.plainStartDate, "dS mmmm")} - ${endWeekDay} ${format(this.course?.plainEndDate, "dS mmmm yyyy")}`;
        },

        getDefaultHolidays() {
            return this.holidays;
        },
    },
    watch: {
        onMapPage(val) {
            this.showManualTitle = !val;
        },
    },
};

export default AddVenuetoCourse;
</script>

<template>
    <div id="loading-overlay" v-show="showOverlay" @click="hideOverlayIfUserClicked">
        <div id="overlay-text">Loading...</div>
    </div>
    <div class="new-listing-advanced-flow ">
        <AdvancedCourseHeader
            :repetition="`${upperFirst(course?.repetition)} recurrence`"
            :course-name="course?.courseName"
            :course-dates="getCurrentCourseDates"
            :course="course"
            :hide-edit="true"
            @submit="submitEditModal($event)"
        />

        <div class="add-avenue-header">
            <h2 id="add-venue-txt">
                {{ showManualTitle ? "Venue summary" : "Add a venue" }}
                <div
                    v-if="showManualTitle"
                    class="summary_header_underneath"
                >
                    Confirm your venue's details.
                </div>
            </h2>
        </div>

        <AutocompleteWithMap
            ref="childMap"
            container-class="new-venue-container"
            @venue-added="addNewVenue"
            @venue-existing-selected="venueExistingSelectedListFor"
            :show-map="showAutocompleteMap"
            :show-enter-manually-button="true"
            :show-all-form-labels="true"
            @enter-manually-changed="manualAutoToggled"
            :show-confirm-button="false"
            :autocomplete-error="autocompleteTxtboxError"
            :existing-venues="existingVenues"
            @map-clicked-lat-ling-updated="userClickedAlocationOnMap"
            @user-clicked-map="userClickedMap"
        />

        <div v-if="showExistingVenueMap" class="course-existing-venue">
            <google-map
                id="map_existing_venue"
                :lng="longi"
                :lat="lati"
                :zoom="zoom"
                :no-move-pin="noMovePin"
                class="mt-4"
            />
        </div>

        <div id="spacery-bottom">&nbsp;</div>

        <Actions
            @next="nextBtn"
            @prev="backActionBtn"
            class="fixed-bottom"
            actions-styles="alt-bottom-actions mx-0"
            :full-width="true"
            :show-spacer="true"
            additional-block-class="col-3"
            :disabled="nextButtonDisabled"
            :next-button-text="nextButtonText"
        />
    </div>
</template>

<style scoped>

.add-avenue-header {
    margin-top: 48px;
}

.summary_header_underneath {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    /* identical to box height */
    /* Body Grey */
    color: #636066;
}

#spacery-bottom {
    padding-bottom: 100px !important;
}

#loading-overlay {
    position: fixed;
    /* display: none; dont set as Vue doesn't like it if you do it explicitly */
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    z-index: 9999;
}

#loading-overlay #overlay-text {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 50px;
    color: white;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
}

</style>
